import sortBy from "lodash/sortBy";

export const STANDARD_PALLET = "Standard Pallet";
export const OVERSIZED_PALLET = "Oversized Pallet";
export const DOUBLE_OVERSIZED_PALLET = "Double Oversized Pallet";
export const MINIMUM_CHARGE = "Minimum Charge";

export const palletTypeOptions = [
  ["normal_pallet", STANDARD_PALLET],
  ["oversized_pallet", OVERSIZED_PALLET],
  ["double_oversized_pallet", DOUBLE_OVERSIZED_PALLET],
  ["minimum_charge", MINIMUM_CHARGE],
];

export const shipmentTypes = sortBy([
  "Crate",
  "Container",
  "Box",
  "Envelope",
  "Lift Van",
  STANDARD_PALLET,
  OVERSIZED_PALLET,
  DOUBLE_OVERSIZED_PALLET,
  "TWC",
  "Bundle",
  "Bucket",
  "Roll",
  "Miscellaneous",
  "Vault",
  "Piece",
  "Tractor Trailer",
  "Straight Truck",
]);
